export const SubscriptionsDetailsDemo = {
    id: 97,
    subscriptionName: 'Envision NEXT - WASA',
    domain: '',
    timeSubscriptionStart: 1703764876,
    timeSubscriptionEnd: 1706443276,
    currentVersion: '',
    installedVersion: '',
    status: 'active',
    userId: 25,
    timeFirstInstallation: 0,
    timeClientUpdate: 0,
    note: '',
    limitBy: 'duration',
    limitByValue: 1,
    packageUnitName: 'month',
    contractPrice: 0,
    contractCurrency: 'USD',
    customerInfo: {
        id: 25,
        firstName: 'Wasa',
        lastName: 'Ltd.',
        fullName: 'Wasa Ltd.',
        primaryEmail: 'wasa@gmail.com',
        primaryPhone: '017171556644',
        primaryAddress: '',
        status: 'active',
        demo: true
    },

    features: [],
    repository: null,
    applicationInfo: {
        id: 16,
        applicationTitle: 'Envision NEXT',
        description: 'Cutting-edge IT system to streamline endoscopy procedures.',
        logoUrl: 'https://storage.googleapis.com/miracle-bucket-23/application_logo/envision.png',
        website: 'https://miracleadvance.com/envisionnext/',
        status: 'active',
        timeCreated: 1701334962,
        demo: true
    },
    subscriptionLogs: [],
    invoices: [
        {
            id: 169,
            currency: 'USD',
            firstName: 'Wasa',
            lastName: 'Ltd.',
            phone: '017171556644',
            email: 'wasa@gmail.com',
            invoiceTitle: 'Envision NEXT - WASA',
            timeIssue: 1703764865,
            timeDue: 1703872865,
            amountBilled: 100,
            amountPaid: 100,
            status: 'active',
            demo: true
        },
        {
            id: 172,
            currency: 'USD',
            firstName: 'Wasa',
            lastName: 'Ltd.',
            phone: '017171556644',
            email: 'wasa@gmail.com',
            invoiceTitle: 'Envision NEXT - WASA',
            timeIssue: 1703771644,
            timeDue: 1703879644,
            amountBilled: 100,
            amountPaid: 0,
            status: 'pending',
            demo: true
        }
    ],
    payments: [
        {
            id: 76,
            userId: 25,
            invoiceId: 169,
            method: 'manual',
            amount: 100,
            currency: 'USD',
            timeInitiate: 1703764872,
            timeSuccess: 1703764872,
            timeFailed: 0,
            note: 'aaa',
            firstName: 'Wasa',
            lastName: 'Ltd.',
            email: '',
            phone: '',
            status: 'paid',
            demo: true
        },
        {
            id: 77,
            userId: 25,
            invoiceId: 169,
            method: 'manual',
            amount: 100,
            currency: 'USD',
            timeInitiate: 1703764872,
            timeSuccess: 1703764872,
            timeFailed: 0,
            note: 'aaa',
            firstName: 'Wasa',
            lastName: 'Ltd.',
            email: '',
            phone: '',
            status: 'paid',
            demo: true
        }
    ],
    packagesPrice: [
        {
            packageId: 39,
            priceId: 81,
            amount: 100,
            vatPercent: 0,
            title: 'Ultra',
            text: '100 USD/120 PPU',
            demo: true
        },
        {
            packageId: 39,
            priceId: 81,
            amount: 100,
            vatPercent: 0,
            title: 'Ultra',
            text: '100 USD/120 PPU',
            demo: true
        }
    ],
    supportTickets: [
        {
            id: 20,
            userId: 6,
            subject: 'Purchase Issue',
            department: 'technical',
            subscriptionId: 103,
            isClosed: false,
            creator: 6,
            timeCreated: 1703944166,
            timeUpdated: 1703944166,
            lastMessage: 'There is a issue on purchasing product.',
            havingAttachment: false,
            isUrgent: true,
            status: 'open',
            demo: true
        },
        {
            id: 21,
            userId: 6,
            subject: 'Purchase Issue',
            department: 'technical',
            subscriptionId: 103,
            isClosed: false,
            creator: 6,
            timeCreated: 1703944166,
            timeUpdated: 1703944166,
            lastMessage: 'There is a issue on purchasing product.',
            havingAttachment: false,
            isUrgent: true,
            status: 'open',
            demo: true
        }
    ],
    demo: true
};

export default null;
